module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('h1', {
    staticClass: "h1c",
    attrs: {
      "id": "core"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "17",
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("THE CORE OF INCLUSIVE LEADERSHIP: THE ENABLING TRAITS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR RESEARCH ON INCLUSIVE LEADER TRAITS HAS")]), _vm._v(" taken us to the land of "), _c('em', [_vm._v("Of course")]), _vm._v(". Of course inclusive leaders need to be authentic, self-assured, and inquisitive. Of course they are emotionally resilient and flexible. Our research uncovered these traits, and our colleagues, as well as those we asked in surveys and focus groups, confirmed that they make sense (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#appb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("appendix B")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/appb#tabAppb_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("table B-1")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But leaders who exhibit these vital personality characteristics without the actionable behaviors and competencies embodied in the five disciplines will remain as feel-good leaders who failed to lead transformation through diversity (getting the mix in the door), inclusion (ensuring the mix is working well), and equity (ensuring that all have equal access, opportunity, support, and reward). Conversely, leaders who focus only on “Tell me what to do and I’ll do it,” without cultivating the enabling traits of inclusive leadership through deeper personal work, will be lacking the energy and credibility sources that enable all of the five disciplines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We have identified eleven enabling traits that reside within the five enabling trait clusters mentioned. As part of the validation process we surveyed talent and diversity and inclusion professionals (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/core#tab0_1"
    }
  }, [_vm._v("table 1")]), _vm._v(", next page). Next, we explore each cluster, calling out some of their less obvious implications for inclusive leadership.")]), _vm._v(" "), _c('table', {
    staticClass: "table2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_c('span', {
    attrs: {
      "aria-label": "18",
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("ENABLING TRAIT CLUSTER")])])]), _vm._v(" "), _c('th', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("DEFINITION")])]), _vm._v(" "), _c('th', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("ENABLING TRAITS")])]), _vm._v(" "), _c('th', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("RESPONDENTS WHO RATE TRAIT CLUSTER "), _c('em', [_vm._v("EXTREMELY IMPORTANT")])])]), _vm._v(" "), _c('th', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("RESPONDENTS WHO RATE TRAIT CLUSTER "), _c('em', [_vm._v("VERY IMPORTANT")])])]), _vm._v(" "), _c('th', {
    staticClass: "tdheadcb"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("TOTAL")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Authenticity")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Expectations of forthrightness in relationships; humility; freedom from arrogance")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Trust")]), _vm._v(" "), _c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Humility")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("63%")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("29%")])]), _vm._v(" "), _c('td', {
    staticClass: "borb"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("92%")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Emotional resilience")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Calm and composed under stress; aware of self in the moment")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Composure")]), _vm._v(" "), _c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Situational self-awareness")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("63%")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("21%")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcb"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("84%")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Self-assurance")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Believes in own capabilities; has positive expectations for the future")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Confidence")]), _vm._v(" "), _c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Optimism")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("25%")])]), _vm._v(" "), _c('td', {
    staticClass: "borbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("42%")])]), _vm._v(" "), _c('td', {
    staticClass: "borb"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("67%")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Inquisitiveness")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Inquisitive; seeks understanding and sense-making; wants to know how others think and feel")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Openness to differences")]), _vm._v(" "), _c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Curiosity")]), _vm._v(" "), _c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Empathy")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("58%")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcbr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("38%")])]), _vm._v(" "), _c('td', {
    staticClass: "tdheadcb"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("96%")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "borr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Flexibility")])]), _vm._v(" "), _c('td', {
    staticClass: "borr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Comfortable when the path forward is not clear")])]), _vm._v(" "), _c('td', {
    staticClass: "borr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Tolerance for ambiguity")]), _vm._v(" "), _c('p', {
    staticClass: "tdpara"
  }, [_vm._v("Adaptability")])]), _vm._v(" "), _c('td', {
    staticClass: "borr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("38%")])]), _vm._v(" "), _c('td', {
    staticClass: "borr"
  }, [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("42%")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdpara"
  }, [_vm._v("80%")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "tabcap"
  }, [_c('a', {
    attrs: {
      "id": "tab0_1"
    }
  }), _c('strong', [_vm._v("Table 1.")]), _vm._v(" Korn Ferry Validated Traits Associated with Inclusive Leadership")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("AUTHENTICITY")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_vm._v("EXPECTATIONS OF FORTHRIGHTNESS IN RELATIONSHIPS; HUMILITY; FREEDOM FROM ARROGANCE")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Trust")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Humility")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The literature on contemporary leadership is replete with research that indicates that "), _c('strong', [_vm._v("authenticity")]), _vm._v(" is one of the most valued traits in leaders. Generation X, Millennials, and Gen Z, having grown up in a time without an expectation of personal privacy, are cynical about leaders and institutions because of all that has been exposed about what happens behind closed doors. They expect that the truth about "), _c('span', {
    attrs: {
      "aria-label": "19",
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("ethical lapses, corporate greed, or government corruption will come out sooner or later.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To create "), _c('em', [_vm._v("trust")]), _vm._v(", leaders must be transparent about who they are, how they make decisions, and how their thinking may be evolving as it is challenged. This is why we begin inclusive leader work with individuals sharing their personal biographies and cultural identities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We start out with the (true) assumption that everyone is diverse. Everyone has a unique, irreplicable story, including those in the majority. Of course, each person also needs to have a grasp on what advantages and disadvantages their diversity has provided them with—this is the work of inclusion and equity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To share and disclose requires "), _c('em', [_vm._v("humility")]), _vm._v(". While there are indeed leaders who grew up privileged, many have stories of growing up poor or in abusive homes. Some of the executives we have coached in the United States were members of White minorities in Black or Latino communities. Others were Black, Latino, or Asian minorities in White communities. Even those who grew up privileged often have mixed feelings about whether their lack of exposure to diversity has stunted their ability to be inclusive. There are myriad permutations. When leaders begin to be open about their stories and their implications, first to themselves and then by sharing them with others, it begins a process of establishing and deepening trust with those within a team or an organization.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But this kind of openness does not come easily at all, and this is not true just for leaders. Much of the failure to leverage diversity comes from the fact that those in the minority often feel the need to downplay or cover who they are because of a lack of trust in the majority culture. "), _c('em', [_vm._v("Covering")]), _vm._v(" is a term that was first used by sociologist Erving Goffman to describe how people with “known stigmatized identities” consciously choose to “mute” those identities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote1",
      "id": "rchcnote1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sixty-one percent of leaders queried in a Deloitte University survey said they cover at work. This includes people of different races, ethnicities, personalities, physical and cognitive abilities, and sexual orientations. Even 45% of straight White males—a group that historically hasn’t been the subject of diversity and inclusion studies—reported covering."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote2",
      "id": "rchcnote2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This generates a Catch-22: I won’t show who I am because it’s not safe, but I won’t trust you if you don’t show me who you are. Inclusive leaders break this cycle by uncovering their identities and being authentic. When they do, this act of humility and of trusting "), _c('span', {
    attrs: {
      "aria-label": "20",
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("those around them, is an enabler to the heavy lifting of each of the five disciplines.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("EMOTIONAL RESILIENCE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_vm._v("CALM AND COMPOSED UNDER STRESS; AWARE OF SELF IN THE MOMENT")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Composure")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Situational self-awareness")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Diversity and inclusion can elicit a significant amount of hidden panic among leaders. After all, they often are the cited evidence that an organization is not diverse or inclusive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, the topics to address are fraught in the social and political discourses of our day, as captured in hashtags such as #BlackLivesMatter, #TimesUp, #NoBanNoWall, #MarchForOurLives, #TakeAKnee, #Dreamers, #LoveIsLove, or #ÉCoisaDePreto (#It’sABlackThing, which was to laud the achievements of Afro-Brazilians). Each of these draws not only fervent supporters who retweet but also fierce opponents who troll. With the power of social media to make any misstatement or action go viral, many leaders are reluctant to go near these trending diversity topics within their organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For this reason, the trait of "), _c('strong', [_vm._v("emotional resilience")]), _vm._v(" is a must-have for leaders who seek to be inclusive. But this work is not for the faint of heart. Across countries, industries, and functions, leaders scored low on this enabling trait cluster in our global inclusive leadership analysis. That is because one of the hardest things about diversity is adapting to unfamiliar people and situations and keeping it together in the midst of the complexities of differences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As inclusive leaders make declarations of the vitalness of diversity and inclusion to the organization, hopes will be raised, but backlash also will ensue. Voices that have long been covered and repressed will begin to be heard; they will begin to challenge and question more openly (as they should). The organization and its leaders will need to listen and be ready to respond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this environment, "), _c('em', [_vm._v("composure")]), _vm._v("—the ability to remain calm and in control in the midst of stress and challenge—is vital. Employees "), _c('span', {
    attrs: {
      "aria-label": "21",
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("understand that the issues are fraught. All sides, for the most part, seek out and value the leaders who can keep it together as the tugs and pulls take place.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inclusive leaders also require "), _c('em', [_vm._v("situational self-awareness")]), _vm._v(" to tune in to the context in which they are about to speak or make a decision. But the contexts they need to be aware of are not just the ones within organizational boundaries; they also need to be tuned in to what is going on in the world at large and how it is affecting their employees. (See "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 12")]), _vm._v(" for more on managing when the outside comes inside.)")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("SELF-ASSURANCE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_vm._v("BELIEVES IN OWN CAPABILITIES; HAS POSITIVE EXPECTATIONS FOR THE FUTURE")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Confidence")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Optimism")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We all know it’s difficult for people to change in their personal lives, and this is no less true of people within organizations. When favored or legacy behaviors have been institutionalized through processes, structure, policies, and requirements, it becomes clear how audacious a declaration to become more diverse and inclusive really is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consider the "), _c('em', [_vm._v("confidence")]), _vm._v(" and "), _c('em', [_vm._v("optimism")]), _vm._v(" all pioneers exhibit in the face of uncertainty and long odds. Examples include NASA, in its quest to get a man on the moon; the Polynesians who embarked on rafts to see where the massive Pacific Ocean currents took them, and landed in South America; Polish-French physicist and chemist Marie Curie, who remains the only person to win the Nobel Prize in two different scientific fields; or gymnast Simone Biles, who performed the first-ever triple double tumbling pass. None of these achievements would have been possible without the people involved possessing the "), _c('strong', [_vm._v("self-assurance")]), _vm._v(" that they could be done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inclusive leaders also require this trait for the very hard, perilous, and long-haul work of diversity and inclusion. Employees may be cynical about the prospect of change, but they also are receptive to those who charge forward with the confidence and optimism to make it happen anyway.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_c('span', {
    attrs: {
      "aria-label": "22",
      "epub:type": "pagebreak",
      "id": "page_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("INQUISITIVENESS")])])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_vm._v("SEEKS UNDERSTANDING AND SENSE-MAKING; WANTS TO KNOW HOW OTHERS THINK AND FEEL")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Openness to differences")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Curiosity")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Empathy")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Inquisitiveness")]), _vm._v(" is the heart and soul of the enabling trait composites. It’s this inquisitive demeanor that pries things wide open when it comes to unleashing the power of diversity in an inclusive way. For all the talk about how organizations need differences for all sorts of compelling reasons, the propulsion inherent in this diversity often remains bottled up—like the fuel in a rocket that sits ready to be ignited and to cause liftoff but never does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only way to ignite diversity and all the power it brings is to tap into it, explore it, and understand it through inquisitiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paradoxically, one of the greatest inhibitors to diversity and inclusion is an early concept of D&I that required the opposite of inquisitiveness: blindness to differences. Among its most hallowed manifestations is Dr. Martin Luther King Jr.’s wish that his children “will not be judged by the color of their skin but by the content of their character.” There is no denying the healing power this approach has had in breaking down the judgments against differences, which often are even codified into law and training solutions. But this uplifting message of unity could potentially make us noninclusive, because this assumption of similarity can mask ways in which we are different and thus can cause us to ignore each individual’s diverse life experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lack of "), _c('em', [_vm._v("curiosity")]), _vm._v(" and "), _c('em', [_vm._v("openness to differences")]), _vm._v(" can lead to a form of bias, an assumption that everyone is the same. The result can be the dismissal or minimization of other people’s feelings, ways of thinking, and experiences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote3",
      "id": "rchcnote3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Furthermore, when openness is limited to just an embrace of those who are different, without an accompanying "), _c('em', [_vm._v("empathy")]), _vm._v(" for their different experiences, people may be reticent to bring their whole selves to work, as they have been invited to do. It negates the very benefits we seek out in attracting greater diversity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the moment where many start to bump into cognitive dissonance. If we call out differences this way—even in the constructive "), _c('span', {
    attrs: {
      "aria-label": "23",
      "epub:type": "pagebreak",
      "id": "page_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("spirit in which it’s meant—what about unity? Does this not create a separation, the very antithesis of what we are after in inclusion? Therein lies the inclusion paradox: in order to achieve inclusion, rather than just focusing on what we have in common, we need to proactively surface our differences as well."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote4",
      "id": "rchcnote4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only way to navigate this paradox and be truly inclusive is to be inquisitive through an openness to the implications of people’s differences, curiosity about who they are and the choices they have made about individual and group identity, and empathy that not only seeks to understand but honors and respects the choices people have made about who they say they are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A study of inclusive leadership by Catalyst shows that people want both unity with others "), _c('em', [_vm._v("and")]), _vm._v(" to have their differences recognized. As the research authors, Jeanine Prime and Elizabeth R. Salib, explain, perceiving similarities with coworkers engendered a feeling of belongingness, while perceiving differences led to feelings of uniqueness. Across the six different countries studied (Australia, China, Germany, India, Mexico, and the United States), these perceptions were strong predictors of inclusion. Employee feelings of uniqueness and belonging contributed, on average, more than 20% to employees’ perceptions of inclusion. Meanwhile, uniqueness accounted for 18% to 24% of an employee’s perception of inclusion, and belonging accounted for 27% to 35%."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote5",
      "id": "rchcnote5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_vm._v("FLEXIBILITY")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_vm._v("COMFORTABLE WHEN THE PATH FORWARD IS NOT CLEAR")]), _vm._v(" "), _c('ul', {
    staticClass: "square"
  }, [_c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Tolerance of ambiguity")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "squ"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("■")]), _vm._v(" Adaptability")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Certainty can be comforting. But when it comes to organizations made up of a diversity of humans, there are way too many situational variables, way too much mystery about human emotions and motivations, and way too many unknowns about what has shaped people’s world-views to be certain about the best way to achieve greater D&I.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inclusive leaders understand that there is no one answer or set of practices that will achieve their goal of diversity and inclusion and unleash the power of all of us. That is because D&I is always about testing and questioning the status quo. (If the status quo were already equitable, there would not be any need for diversity and inclusion "), _c('span', {
    attrs: {
      "aria-label": "24",
      "epub:type": "pagebreak",
      "id": "page_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("interventions.) This means that inclusive leaders must be adept at moving from a place of organizational and individual certainty to one of exceptional "), _c('strong', [_vm._v("flexibility")]), _vm._v(". They must have a "), _c('em', [_vm._v("tolerance for ambiguity")]), _vm._v(", because the contexts in which they find themselves are not always clear and we really don’t know what the future holds. They must demonstrate "), _c('em', [_vm._v("adaptability")]), _vm._v(" to situations in which the information is always incomplete and vital voices often are missing from the room.")])]), _vm._v(" "), _c('div', {
    staticClass: "side1"
  }, [_c('p', {
    staticClass: "side1t"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  }), _vm._v(" THE CHALLENGE WITH TRAITS: CAN PEOPLE REALLY CHANGE WHO THEY ARE?")]), _vm._v(" "), _c('p', {
    staticClass: "sideaut"
  }, [_c('em', [_vm._v("Sarah Hezlett, Minneapolis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The very definition of a trait, as a personal, distinguishing characteristic or quality, makes it seem immutable and enduring. But can people change and develop their traits? A growing body of research says yes. While your traits may be relatively stable, they are not fixed in stone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Through adulthood, our personalities continue to change. On average, people tend to become warmer. They grow more responsible. Calmer. More confident. And these trends suggest that personality change is not always short-term or temporary. Personality changes can stick."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote6",
      "id": "rchcnote6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Evidence suggests that these changes are not just a function of maturing or aging but of life events. Individuals’ traits shift, both in anticipation of and as a consequence of life experiences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote7",
      "id": "rchcnote7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("This is good news for those seeking to be more inclusive leaders. Not only is it possible to develop the disciplines of inclusive leadership but also people can shift their traits to be more enabling and supportive of inclusive behaviors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Melinda Gates, Cochair of the Bill & Melinda Gates Foundation, is an example of someone who has changed something fundamental about who she is. In her book "), _c('em', [_vm._v("The Moment of Lift")]), _vm._v(", she writes, “I am a private person—in certain ways, a bit shy. I was the girl in school who raised her hand to speak while other kids bellowed their answers from the back row. I like to work offstage.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote8",
      "id": "rchcnote8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("But personal and public experiences led her to change. She wrestled with the unresolved impact of a previous abusive relationship in her life and went through an identity crisis as she transitioned from being a corporate leader to a stay-at-home mom. Then, as the leader of a high-profile organization, she came face to face with realities that called for her to be more outspoken. She opted to transform herself into a highly visible public advocate for empowering women—a huge shift for her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Despite her fears about being the focus of public controversy, particularly as a Catholic, Gates considered the importance of serving as a role model for her children, the previous experiences she valued and wanted to honor, the beliefs she learned from her mother, and the morality of failing to act. As a profile of her in the "), _c('em', [_vm._v("Christian Science Monitor")]), _vm._v(" described it, “The more she learned about the struggles of poor women in Africa and Asia—including the discrimination and abuse they faced from husbands who, for example, beat their wives for using birth control—the stronger her voice became.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chcnote9",
      "id": "rchcnote9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Developing new traits involves disruption. We need to step out of established routines and get uncomfortable. We need to critically reflect on what habits and beliefs serve us, and what gets in our way—often with guidance from others. And we need to embrace new experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Yes, it is possible for people’s traits to change. And as Melinda Gates’s story demonstrates, growing one’s enabling traits builds the capacity for inclusive leadership.")]), _vm._v(" "), _c('p', {
    staticClass: "centerg"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In martial arts, a stiff stance sets one up for an easy takedown. So, too, with leading inclusively. Instead, assume a flexible crouch and you will have the greatest set of options to counter the next strike of injustice, inequity, and exclusion.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "line3"
  }, [_c('span', {
    attrs: {
      "aria-label": "25",
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("TRAITS AND DISCIPLINES GO HAND IN HAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leaders who exhibit the vital personality traits of authenticity, emotional resilience, self-assurance, inquisitiveness, and flexibility are critical to D&I efforts. But without the actionable behaviors embodied in the five disciplines, these leaders will fall short in achieving D&I transformation. In "), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_vm._v("part 1")]), _vm._v(", we will explore the five disciplines that operationalize inclusive leadership and unleash the power of us all.")]), _vm._v(" "), _c('p', {
    staticClass: "centerg"
  }, [_vm._v("■   ■   ■")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6330a06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/core.vue
// module id = 78
// module chunks = 0